<template>    
    <div>
        <v-container grid-list-lg>
            <v-layout row wrap>
 <v-flex xs12>
          <h2 class="text-xs-center feature_products_title">Shopping <span> Cart</span></h2>
          <div class="title_border"></div>
        </v-flex>


                <v-flex xs12  class="cart_table">
                    <v-data-table
                    :headers="headers"
                    :items="cart"
                  
                    :search="search"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="pagination"
                    row
                    wrap
                    class="elevation-1"
                    >
                        <template slot="items"  slot-scope="props" >                            
                            <td class="text-xs-left"><v-icon @click="removeCart(props.index)" small>close</v-icon></td>
                            <td class="text-xs-left">                       
                                <v-img :src="props.item.product.image" aspect-ratio="1" style="width:55px;"> </v-img>
                            </td>
                               <td class="text-xs-left">{{ props.item.product.code }}</td>
                            <td class="text-xs-left">{{ props.item.product.item_name }}</td>
                       
                            <td class="text-xs-center  align-center d-flex item_table pa-3">
                                 
                                <v-icon @click="increaseQuantity(props.index)" class="add">add</v-icon>
                                
                                <v-card-text class="quantity_no">{{props.item.quantity}}</v-card-text>
                      
                                <v-card-actions v-if="props.item.quantity > 1">                                    
                                <v-icon @click="decreaseQuantity(props.index)" class="remove">remove</v-icon>
                                </v-card-actions>
                                <v-card-actions v-else>
                                <v-icon class="remove">remove</v-icon>
                                </v-card-actions>
                              
                            </td>
                       
                            <td>
                             <v-btn small flat    color="red"   :to="'/product/' + props.item.product.id">Detail</v-btn>
                            </td>
                            <td class="text-xs-left">KOL</td>
                            <td class="text-xs-left">{{ props.item.product.packageamount }}</td>
                            <td class="text-xs-left" v-if="props.item.product.iscampaign==false">{{ props.item.product.package_price }}</td>
                            <td class="text-xs-left" v-else>{{ props.item.product.discounted_package_price }}</td>
                            <td class="text-xs-left">{{ props.item.product.vatpercent }}</td>
                            <td class="text-xs-left" v-if="props.item.product.iscampaign==false"> {{(props.item.product.package_price*props.item.quantity).toFixed(2)}}</td>                    
                            <td class="text-xs-left" v-else> {{(props.item.product.discounted_package_price*props.item.quantity).toFixed(2)}}</td>                    
                            <!-- <td class="text-xs-left"> {{(props.item.product.package_price*props.item.quantity).toFixed(2)}}</td>                     -->
                        </template>
                    </v-data-table>  
                </v-flex>
                <v-flex xs12 >
                    <v-card>
                        <v-list style="border-bottom:1px solid #E0E0E0;">
                            <v-list-tile>
                            <v-list-tile-title  class="grey--text text--darken-3 title ">Ostoskärry</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                        <v-list style="border-bottom:1px solid #E0E0E0;">
                            <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title class="body-1">Ostoskori Yhteensä<span class="right main_font_color">{{currency}}{{cartTotal}}</span>
                                </v-list-tile-title>
                            </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                            <v-list style="border-bottom:1px solid #E0E0E0;">
                            <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title class="body-1">ALV Hinta - %14<span class="right main_font_color">{{currency}}{{VatTotal14}}</span>
                                </v-list-tile-title>
                            </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                       
                            <v-list style="border-bottom:1px solid #E0E0E0;">
                            <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title class="body-1">ALV Hinta - %24<span class="right main_font_color">{{currency}}{{VatTotal24}}</span>
                                </v-list-tile-title>
                            </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                          <!-- <v-list style="border-bottom:1px solid #E0E0E0;">
                            <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title class="body-1">ALV Hinta - Summa<span class="right main_font_color">{{currency}}{{VatTotal}}</span>
                                </v-list-tile-title>
                            </v-list-tile-content>
                            </v-list-tile>
                        </v-list> -->
                        <!-- <v-flex xs12 d-flex class="right_part_shipment" style="border-bottom:1px solid #E0E0E0;">
                            <v-flex xs6 class="shipment">
                                <p class="body-1">ALV Hinta</p>
                            </v-flex>
                            <v-flex xs6 class="shipping_cost main_font_color">                             
                                <p><span>{{currency}}{{Vat_Total.toFixed(2)}}</span></p>
                            </v-flex>
                        </v-flex> -->
                        <v-list>
                            <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title class="title grey--text text--darken-3">Kokonaishinta<span class="right main_font_color">{{currency}}{{cartTotalWithShipping}}</span>
                                </v-list-tile-title>
                            </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                        <v-list>
                            <v-list-tile-action>
                                <v-btn @click="checkout()" block class="mx-3 mb-3 green white--text">Tilaussivu</v-btn>                            
                            </v-list-tile-action>
                            <p style="color:red;text-align:center;margin-bottom:5px;" v-if="this.feedback">{{this.feedback}}</p>
                        </v-list>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
     
  <script>
   import firebase from "firebase";
    const functions = firebase.functions()



import axios from "axios";
import EventServicex from "@/services/EventService.js"


   import moment from 'moment'   
   export default {
    data(){
        return{
            currency:null,
            search:'',
            userId:null,             
            userLoggedin:null,
            account:[],
            customers:[],
            shipping:null,
            Vat_Total:0,
            rowsPerPageItems: [8, 16, 24],
            pagination: {
             rowsPerPage: 8
            },      
            feedback:null,
            headers: [                
              { text: 'Poistaa', sortable: !1 },  
              { text: 'Kuva' , sortable: !1 },  
              { text: 'Code' , sortable: !1 },  
              { text: 'Tuote' , sortable: !1 },
              { text: 'Pala', sortable: !1 },
              { text: 'Yksityiskohta', sortable: !1 },
              { text: 'Sales Unit', sortable: !1 },
              { text: 'Package Size', sortable: !1 },
              { text: 'Hinta-€', sortable: !1 },                                         
              { text: 'ALV-%', sortable: !1 },                                         
              { text: 'Summa-€', sortable: !1 },                                         
            ],
            cart:this.$store.getters.cart                       
        }
    },
 methods:{
        removeCart(index){
            // console.log("index:" + item)
            //    const index = this.cart.indexOf(item)
               console.log("index:" + index)
            this.$store.commit('removeCart', index)     
        },
        checkout(){

//    let res =  axios.get("http://localhost:5001/elatukku-23ef3/us-central1/getcategories")

//                   .catch((console.error('update list command get failed:',error)
//                   ));

//    let res =  axios.get("http://localhost:5001/elatukku-23ef3/us-central1/getproducts")

//                   .catch((console.error('update list command get failed:',error)
//                   ));



            if(this.cart.length > 0 ){
                if(this.userLoggedin == true){
                  this.$router.replace('/checkout')
             //     location.reload();     
                }else{
                  this.$router.replace('/sign-in') 
                }
            }else{
                this.feedback = "Please add item to cart for checkout";  
            }  
        },
        increaseQuantity(index){
            this.$store.commit('increaseQuantity', index)
              console.log(this.cart);
        },
        decreaseQuantity(index){
            this.$store.commit('decreaseQuantity', index)
        }
    },
    computed:{
        cartTotal(){                  
            var total=0;
            this.cart.forEach(item => {
                if(item.product.iscampaign==false)                
                total += parseFloat(item.product.package_price * item.quantity)
                 else                
                total += parseFloat(item.product.discounted_package_price * item.quantity)
            });
            return total.toFixed(2);
        },
        // VatTotal(){
        //  var vat_sum=0;
        //     this.cart.forEach(item => {
        //         if(item.product.vatpercent=="14.0")
        //         vat_sum+=parseFloat(item.product.package_price*item.quantity)*14/100;
        //         else if(item.product.vatpercent=="24.0")
        //         vat_sum+=parseFloat(item.product.package_price*item.quantity)*24/100;
             
        //     });
        //     return vat_sum.toFixed(2);
        // },
        VatTotal14(){
         var vat_sum=0;
            this.cart.forEach(item => {
                if(item.product.vatpercent=="14.0")
                {
                    if(item.product.iscampaign==false)
                vat_sum+=parseFloat(item.product.package_price*item.quantity)*14/100;  
                else
                vat_sum+=parseFloat(item.product.discounted_package_price*item.quantity)*14/100;  
                }
            });
            return vat_sum.toFixed(2);
        },
         VatTotal24(){
         var vat_sum=0;
            this.cart.forEach(item => {
                if(item.product.vatpercent=="24.0")
                {
                      if(item.product.iscampaign==false)
                vat_sum+=parseFloat(item.product.package_price*item.quantity)*24/100;
                else
                 vat_sum+=parseFloat(item.product.discounted_package_price*item.quantity)*24/100;
                }
            });
            return vat_sum.toFixed(2);
        },
        cartTotalWithShipping(){
            var total=0;
            var vat_sum=0;
            this.cart.forEach(item => {
                if(item.product.vatpercent=="14.0")
                {
                    if(item.product.iscampaign==false)
                    {
                        total += parseFloat(item.product.package_price * item.quantity)
                vat_sum+=parseFloat(item.product.package_price*item.quantity)*14/100;
                    }
                else
                {
                    total += parseFloat(item.product.discounted_package_price * item.quantity)
                vat_sum+=parseFloat(item.product.discounted_package_price*item.quantity)*14/100;
                }
                }
                else if(item.product.vatpercent=="24.0")
                {
                    if(item.product.iscampaign==false)
                    {
                        total += parseFloat(item.product.package_price * item.quantity)
                vat_sum+=parseFloat(item.product.package_price*item.quantity)*24/100;
                    }
                else
                {
                vat_sum+=parseFloat(item.product.discounted_package_price*item.quantity)*24/100;
                total += parseFloat(item.product.discounted_package_price * item.quantity)
                }
                }

             //   total += parseFloat(item.product.package_price * item.quantity)
            });
            return (parseFloat(total)+parseFloat(vat_sum)).toFixed(2);
        }          
    },
    created(){
        var db = firebase.firestore();
        
        // Current Currency   
        db.collection("settings").doc('config').onSnapshot(doc =>{
          this.currency = doc.data().currency
        })
        
        // Current Shipping Fee
        db.collection("settings").doc('config').onSnapshot(doc =>{
            this.shipping = doc.data().shipping
        })

        var user = firebase.auth().currentUser;
        if (user) {
            this.userLoggedin = true;                
        } else {
            this.userLoggedin = false;            
        }        
    }  
   }
 </script>
  
<style scoped>
    a {
    text-decoration: underline;  
    }
    .elevation-1 {
        margin:0!important;
    }
    .item_table .v-card__text{
    padding:0px !important;
    }
    .v-list__tile {
    height: 38px;
    }  
    .item_table{
        height:auto;
        padding: 0;
    
    }
    .item_table .v-card__actions{
        padding:0;
    }
    .item_table .material-icons  {
        font-size: 24px;
    }

    .item_table .add{
        cursor:pointer;
        color: green;
        border:1px solid #E0E0E0;
      
        width:35px;
    }
    .item_table .remove{
        cursor:pointer;
        color:red;
        border:1px solid #E0E0E0;
       
        width:35px;
    }
    .item_table .quantity_no{
        border:1px solid #E0E0E0;
    
        width: 35px;
        height: 26px;
  
        
    }
    .item_table .total{
        height: auto;
        width:15%; 
        display: grid;
        justify-items: center;
        align-items: center;
        text-align: center;
    }
    .right_part_shipment .shipment{
        display: grid;
        align-items: center;
    }
    .shipping_cost{
        text-align: right;
    }
    .shipping_cost p:nth-of-type(1){
        margin-top: 10px;
    }
</style>




// WEBPACK FOOTER //
// src/components/shop/checkout/Cart.vue